import AuthForm from './AuthForm';

interface Props {
  onBack: () => void;
}

/**
 * Connexion conducteur.
 *
 * Le formulaire parle à la micro-API PHP. Ce qui n'est jamais envoyé par le
 * navigateur : le paramètre `role`. L'ancien `signUp(email, password, name,
 * 'driver')` laissait le client choisir son propre rôle — c'était la faille.
 * Le rôle est attribué par la base à la création du profil.
 */
export default function DriverLogin({ onBack }: Props) {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <div className="bg-blue-600 px-6 pt-14 pb-8">
        <button
          onClick={onBack}
          className="w-9 h-9 flex items-center justify-center rounded-full bg-white/20 mb-5"
          aria-label="Retour"
        >
          <i className="ri-arrow-left-line text-white text-lg"></i>
        </button>
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 rounded-2xl bg-white/15 flex items-center justify-center border border-white/20">
            <i className="ri-steering-2-line text-white text-2xl"></i>
          </div>
          <div>
            <h1 className="text-white font-bold text-xl tracking-tight">Conducteur</h1>
            <p className="text-blue-200 text-xs mt-0.5">Vos trajets et vos indemnités</p>
          </div>
        </div>
      </div>

      <div className="flex-1 px-5 pt-5 pb-10 flex flex-col items-center">
        <AuthForm />
      </div>
    </div>
  );
}
